import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import { setUserFromAuth0 } from "redux/actions/UserActions";
import { CircularProgress } from "@material-ui/core";

const ToUrl = (props) => {
    const { user, isAuthenticated, isLoading, loginWithRedirect, logout  } = useAuth0();
    const history = useHistory();
    const location = useLocation();
    const pathAndQuery = location.pathname + location.search;
    const urlParams = new URLSearchParams(window.location.search);
    const url = urlParams.get("url");
    const email = decodeURIComponent(atob(urlParams.get("user")));

    useEffect(() => {
        (async () => {
        if(!isAuthenticated && !isLoading){
            setUserFromAuth0();
            return loginWithRedirect({
                appState: { returnTo: url }, 
            })
        }
        else if(isAuthenticated){
            if(user.email != email){
                setUserFromAuth0();
                logout({ logoutParams: { returnTo: `${window.location.origin}?returnTo=${btoa(pathAndQuery)}`, federated: true } });
            }
            else{
                history.replace(url || "/");
            }
        }
        })();
    }, [isAuthenticated, isLoading]);

    if (isLoading) {
        return (<div className="loader"><CircularProgress  /></div>);
    }
    return ("");
};


export default ToUrl;